module.exports = __webpack_public_path__ + "static/media/Shkatulka.2b577392.mp3";